import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { cohortActions } from '../../../store';
import { areUserRolesIn } from '../../../helpers';
import { BTSessionStatus, Roles } from '../../../constants';
import { CQAReviewStatus } from '../../../components/layout/qa/constants';

import type { UseSessionAcknowledgementGuardParams } from './types';

export const useSessionAcknowledgementGuard = ({
  session,
  user,
  sessionId,
  checkForCQAReview,
  setOpenSessionNotAcknowledgedDialog,
}: UseSessionAcknowledgementGuardParams) => {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (!session || !user || !sessionId) return;

    if (areUserRolesIn(user?.roles, [Roles.Vbt])) {
      dispatch(
        cohortActions.getClientCohortAssignments({
          params: { client_id: session.client_id },
          getAccessTokenSilently,
        }),
      );
    }

    if (
      areUserRolesIn(user?.roles, [Roles.Prbt, Roles.Vbt]) &&
      (session.status === BTSessionStatus.EditsRequested ||
        session.status === BTSessionStatus.Completed) &&
      session.clinical_qa_review?.status !== CQAReviewStatus.Acknowledged
    ) {
      setOpenSessionNotAcknowledgedDialog(true);
    } else {
      setOpenSessionNotAcknowledgedDialog(false);
      checkForCQAReview();
    }
  }, [
    checkForCQAReview,
    dispatch,
    getAccessTokenSilently,
    session,
    sessionId,
    setOpenSessionNotAcknowledgedDialog,
    user,
  ]);
};
